@let showError = !validating && !disabled && !!control.errors && (touched || dirty);
@let hasLookupBtn = !config?.hideLookupBtn && !!officeField.AvailableLookups?.length;
<div
  class="app-control-wrapper__wrapper"
  [ngClass]="{
    'app-control-wrapper__wrapper--left_aligned': alignment === controlLabelAlignment.Left,
  }">
  <label class="app-control-wrapper__wrapper__title">
    {{ labelLocalization$() || officeField.RecordLabel }}
  </label>
  <div class="app-control-wrapper__form-item">
    <div
      class="input-group app-control-wrapper__control"
      [ngClass]="{
        'app-control-wrapper__control--required': !disabled && required,
        'app-control-wrapper__control--validating': validating,
        'app-control-wrapper__control--hide-error': !showError,
        'app-control-wrapper__control--invalid': showError,
        'app-control-wrapper__control--has-lookup': hasLookupBtn,
      }">
      <ng-content></ng-content>
      @if (hasLookupBtn) {
        <div class="input-group-append">
          <app-lookup-button
            [officeField]="officeField"
            [formGroupInstance]="formGroupInstance"
            [disabled]="disabled || validating"
            [config]="config"></app-lookup-button>
        </div>
      }
    </div>
    @if (!config?.hideLabelStatus) {
      @for (labelDescView of labelDescriptionViews; track labelDescView.seq) {
        @let labelDescriptionText = labelDescView.control?.Value | asyncStatusFromLabelValue: labelDescView | async;
        @if (labelDescriptionText) {
          <div
            class="form-control"
            [ngClass]="{
              'app-control-wrapper__wrapper__label': labelDescView.type === LabelTypeEnum.Description,
              'app-control-wrapper__wrapper__status': labelDescView.type === LabelTypeEnum.Status,
            }"
            title="{{ labelDescriptionText }}">
            {{ labelDescriptionText }}
          </div>
        }
      }
    }
  </div>
</div>
@if (showError) {
  <app-control-errors [control]="control" [officeField]="officeField" [errorsMessagesOverridesRegistry]="errorsMessagesOverridesRegistry">
  </app-control-errors>
}
